var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8284 4.22876L8.00001 7.05719L5.17158 4.22876C5.04656 4.10374 4.87699 4.0335 4.70018 4.0335C4.52336 4.0335 4.3538 4.10374 4.22877 4.22876C4.10375 4.35379 4.03351 4.52336 4.03351 4.70017C4.03351 4.87698 4.10375 5.04655 4.22877 5.17157L7.0572 8L4.22877 10.8284C4.10375 10.9535 4.03351 11.123 4.03351 11.2998C4.03351 11.4766 4.10375 11.6462 4.22877 11.7712C4.3538 11.8963 4.52336 11.9665 4.70018 11.9665C4.87699 11.9665 5.04656 11.8963 5.17158 11.7712L8.00001 8.94281L10.8284 11.7712C10.9535 11.8963 11.123 11.9665 11.2998 11.9665C11.4767 11.9665 11.6462 11.8963 11.7712 11.7712C11.8963 11.6462 11.9665 11.4766 11.9665 11.2998C11.9665 11.123 11.8963 10.9535 11.7712 10.8284L8.94282 8L11.7712 5.17157C11.8963 5.04655 11.9665 4.87698 11.9665 4.70017C11.9665 4.52336 11.8963 4.35379 11.7712 4.22876C11.6462 4.10374 11.4767 4.0335 11.2998 4.0335C11.123 4.0335 10.9535 4.10374 10.8284 4.22876Z",
    fill: "#AFAFAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGray);
export default __webpack_public_path__ + "static/media/cross-gray.1255d87a8097885038ca817f726eace3.svg";
export { ForwardRef as ReactComponent };